import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HeroBanner() {
  const topComics = comics.filter((c) => c.isHot).slice(0, 4);

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20Korean%20manhwa%20webtoon%20aesthetic%20banner%2C%20abstract%20flowing%20ink%20and%20gradient%20shapes%2C%20warm%20amber%20and%20deep%20charcoal%20color%20palette%2C%20modern%20minimal%20digital%20art%2C%20soft%20atmospheric%20lighting%2C%20no%20text%2C%20artistic%20composition%20with%20dramatic%20contrast&width=1800&height=1000&seq=hero-bg-home&orientation=landscape"
          alt="36漫画网 - 免费韩漫大全"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
              <div className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse"></div>
              <span className="text-white/90 text-xs font-medium whitespace-nowrap">每日更新 · 无删减韩漫</span>
            </div>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white leading-tight mb-4">
              韩国漫画
              <span className="block text-accent-400">下拉式阅读新体验</span>
            </h1>
            <p className="text-white/70 text-sm md:text-base max-w-lg mb-8 leading-relaxed">
              36漫画网提供无删减韩国漫画下拉式阅读，免费韩漫大全涵盖各类热门作品，界面简洁、操作简单，让您快速找到并阅读喜爱的韩漫。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <Link
                to="/category/all"
                className="px-7 py-3 text-sm font-medium bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                立即浏览
                <i className="ri-arrow-right-up-line"></i>
              </Link>
              <Link
                to="/about"
                className="px-7 py-3 text-sm font-medium text-white border border-white/30 rounded-full hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
            <div className="flex items-center gap-6 mt-8 justify-center lg:justify-start">
              {[
                { num: '1,000+', label: '精品韩漫' },
                { num: '50万+', label: '活跃读者' },
                { num: '99.9%', label: '好评率' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-white font-bold text-lg md:text-xl whitespace-nowrap">{stat.num}</div>
                  <div className="text-white/50 text-xs whitespace-nowrap">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg">
            <div className="grid grid-cols-2 gap-3 md:gap-4">
              {topComics.map((comic, idx) => (
                <Link
                  key={comic.id}
                  to={`/article/${comic.slug}`}
                  className={`group relative rounded-xl overflow-hidden ${idx === 0 ? 'col-span-2 aspect-[2.2/1]' : 'aspect-[3/4]'} cursor-pointer`}
                >
                  <img
                    src={comic.coverImage}
                    alt={comic.title}
                    title={`${comic.title} - 韩国漫画无删减`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <span className="inline-block px-2 py-0.5 bg-white/90 text-foreground-800 text-[10px] font-medium rounded-full whitespace-nowrap">
                      {comic.title}
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}